import React, { useState } from 'react';
import {
	MDBCol, MDBRow, MDBModalBody, MDBBox, MDBCardFooter, MDBAlert
} from "mdbreact";
import { Button, Dialog, Text } from "evergreen-ui";
import { Input } from "antd";
import { MDBCard, MDBCardBody } from "mdbreact";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref, update } from "firebase/database";
import { getAuth, signOut, signInWithEmailAndPassword, updatePassword, updateEmail } from "firebase/auth";


const db = getDatabase(Firebase);
const auth = getAuth(Firebase);
const AdminSettingsLayout = (props) => {
	const canUpdate = props.canUpdate !== false;

	const [modal, setModal] = React.useState(false);
	const [modal2, setModal2] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const [color, setColor] = useState("info");
	const [showAlert, setShowAlert] = useState(false);
	const [message, setMessage] = useState("");

	const toggleModal = () => {
		setModal(!modal);
	}

	const toggleModal2 = () => {
		setModal2(!modal2);
	}

	const showPrompt = (type) => {

		if (type === "email") {
			setModal2(true);
			setModal(false);

		} else if (type === "password") {
			setModal(true);
			setModal2(false);

		} else {
			console.log("type is null");
			setModal(false);
			setModal2(false);
		}
	}

	const handleLogout = () => {
		signOut(auth)
			.then(() => {
				window.location.href = "/";
				window.location.hash = "no-back-button";
				window.location.hash = "Again-No-back-button";//again because google chrome don't insert first hash into history
				window.onhashchange = function () { window.location.hash = "no-back-button"; }
			}).catch((err) => {
				alert("oops an error occurred : " + err);
			});
	}

	const handlePasswordChange = () => {
		if (!canUpdate) {
			setColor("danger");
			setMessage("You do not have permission to update admin settings.");
			setShowAlert(true);
			setTimeout(() => {
				setShowAlert(false);
			}, 3000);
			return;
		}

		setLoading(true);
		var email = document.getElementById("email").value;
		var passOne = document.getElementById("passOne").value;
		var passTwo = document.getElementById("passTwo").value;
		//var newPassword2 = document.getElementById("newPassword2").value;

		console.log(email, passOne, passTwo);

		if (email == null || passOne == null || passTwo == null) {
			//passwords don't match
			setColor("danger");
			setMessage("Fields cannot be left empty!!");
			setShowAlert(true);
			setTimeout(() => {
				setShowAlert(false);
			}, 3000);
		} else {
			console.log(email + "-" + passOne);

			signInWithEmailAndPassword(auth, email, passOne)
				.then(function (user) {
					console.log(user.user.uid);
					updatePassword(auth.currentUser, passTwo)
						.then(function () {
							update(ref(db, "talmidsdb/users/" + user.user.uid), { password: passTwo });
							setColor("success");
							setMessage("Updated successfully");
							setShowAlert(true);
							setTimeout(() => {
								setShowAlert(false);
							}, 3000);
							setLoading(false);
							setModal(false);
							handleLogout();

						})
						.catch(function (error) {
							setColor("danger");
							setMessage("Unable to add due to an error");
							setShowAlert(true);
							setTimeout(() => {
								setShowAlert(false);
							}, 3000);
							setLoading(false);
						});

				})
				.catch(function (error) {
					setColor("danger");
					setMessage("Unable to update due to an error");
					setShowAlert(true);
					setTimeout(() => {
						setShowAlert(false);
					}, 3000);
					setLoading(false);
				});
		}
	}
	const handleEmailChange = () => {
		if (!canUpdate) {
			setColor("danger");
			setMessage("You do not have permission to update admin settings.");
			setShowAlert(true);
			setTimeout(() => {
				setShowAlert(false);
			}, 3000);
			return;
		}

		var oldEmail = document.getElementById("oldEmail").value;
		var currentPass = document.getElementById("password").value;
		var newEmail = document.getElementById("newEmail").value;

		console.log(oldEmail, currentPass, newEmail);
		setLoading(true);

		signInWithEmailAndPassword(auth, oldEmail, currentPass)
			.then(function (user) {

				updateEmail(auth.currentUser, newEmail)
					.then(function () {
						update(ref(db, "talmidsdb/users/" + user.user.uid), { email: newEmail });
						setColor("success");
						setMessage("Updated successfully");
						setShowAlert(true);
						setTimeout(() => {
							setShowAlert(false);
						}, 3000);
						setModal2(false);
						setLoading(false);
					})
					.catch(function (error) {
						setColor("danger");
						setMessage("Unable to update due to an error");
						setShowAlert(true);
						setTimeout(() => {
							setShowAlert(false);
						}, 3000);
						setLoading(false);
					});

			})
			.catch(function (error) {
				setColor("danger");
				setMessage("Unable to update due to an error");
				setShowAlert(true);
				setTimeout(() => {
					setShowAlert(false);
				}, 3000);
				setLoading(false);
			});

	}
	const PasswordModal = () => (
		<div className="font-Nunito">
			<Dialog isShown={modal} hasFooter={false} title={"Change Account Password"} onCloseComplete={toggleModal}>
				<MDBModalBody>
					<MDBRow>
						<MDBCol className="px-5">
							<div className="d-flex flex-column ">
								<div className="d-flex flex-column">
									<Text className=" mb-1">Enter email address</Text>
									<Input type="email"
										placeholder="enter email"
										className="w-100 mr-4"
										id="email" />

								</div>
								<div className="d-flex flex-row mt-3 ">
									<div className="d-flex flex-column w-100 mr-4">
										<Text className=" mb-1">Enter current password</Text>
										<Input type="password"
											placeholder="enter old password"
											className="w-100"
											id="passOne" />

									</div>
									<div className="d-flex flex-column w-100 ml-4">
										<Text className=" mb-1">Enter preferred new Password</Text>
										<Input type="password"
											placeholder="enter new password"
											className="w-100"
											id="passTwo" />
									</div>

								</div>

							</div>
							<Button appearance="primary" isLoading={loading} disabled={!canUpdate} className="mt-3" onClick={() => {
								handlePasswordChange();
							}}>Update Password</Button>

						</MDBCol>
					</MDBRow>
				</MDBModalBody>
			</Dialog>
		</div>
	);

	const EmailModal = () => (
		<div>
			<Dialog isShown={modal2} hasFooter={false} title={"Change Account Email"} onCloseComplete={toggleModal2}>
				<MDBModalBody>
					<MDBRow>
						<MDBCol className="px-5">
							<div className="d-flex flex-column ">
								<div className="d-flex flex-column">
									<Text className=" mb-1">Enter email address</Text>
									<Input type="email"
										placeholder="enter email"
										className="w-100 mr-4"
										id="oldEmail" />

								</div>
								<div className="d-flex flex-row mt-3 ">
									<div className="d-flex flex-column w-100 mr-4">
										<Text className=" mb-1">Enter current password</Text>
										<Input type="password"
											placeholder="enter old password"
											className="w-100"
											id="password" />

									</div>
									<div className="d-flex flex-column w-100 ml-4">
										<Text className=" mb-1">Enter preferred new email</Text>
										<Input type="email"
											placeholder="enter new email"
											className="w-100"
											id="newEmail" />
									</div>

								</div>

							</div>
							<Button appearance="primary" isLoading={loading} disabled={!canUpdate} className="mt-3" onClick={() => {
								handleEmailChange();
							}}>Update Email</Button>

						</MDBCol>
					</MDBRow>
				</MDBModalBody>
			</Dialog>
		</div>
	);

	return (
		<div>
			<MDBBox>
				{showAlert ?
					<>
						<MDBAlert color={color} className="my-3" >
							{message}
						</MDBAlert>
					</>
					: null}
				<MDBRow className="w-100 my-2 d-flex justify-content-center">
					<MDBCol md={4}>
						<MDBCard color={"blue lighten-5"} className="my-2" style={{ height: "8rem" }}>
							<MDBCardBody className="px-3">
								<span>
									<Text family='Nunito' className="font-weight-bolder">Change Admin Email</Text>
								</span>
							</MDBCardBody>

							<MDBCardFooter>
								<Button appearance="primary" disabled={!canUpdate} onClick={() => { showPrompt("email") }}>GO</Button>
							</MDBCardFooter>
						</MDBCard>
					</MDBCol>
					<MDBCol md={4}>
						<MDBCard color={"blue lighten-5"} className="my-2" style={{ height: "8rem" }}>
							<MDBCardBody className="px-3">
								<span>
									<Text family='Nunito' className="font-weight-bolder">Change Admin Password</Text>
								</span>
							</MDBCardBody>
							<MDBCardFooter>
								<Button appearance="primary" disabled={!canUpdate} onClick={() => { showPrompt("password") }}>GO</Button>
							</MDBCardFooter>
						</MDBCard>
					</MDBCol>
				</MDBRow>
				<PasswordModal />
				<EmailModal />
			</MDBBox>
		</div>
	)
}
export default AdminSettingsLayout;
